import UserHome from '@/views/userCenter/UserHome'
// import MyAppointment from '@/views/userCenter/myAppointment/MyAppointment.vue'
// console.log(MyAppointment)
export default [
  {
    path: '/usercenter',
    component: UserHome,
    children: [
      {
        path: '',
        name: 'messagecenter',
        meta: {
          title: '消息中心'
        },
        component: () => import('@/views/userCenter/MessageCenter.vue')
      },
      {
        path: 'maintaincompany',
        name: 'maintaincompany',
        meta: {
          title: '企业信息维护'
        },
        component: () => import('@/views/userCenter/MaintainCompany.vue')
      },
      {
        path: 'buyinginformation',
        name: 'buyinginformation',
        meta: {
          title: '求购信息'
        },
        component: () => import('@/views/userCenter/BuyingInformation.vue')
      },
      {
        path: 'myshop',
        name: 'myShop',
        meta: {
          title: '我的求购'
        },
        component: () => import('@/views/userCenter/myShop/lookMessage.vue')
      },
      {
        path: 'maintainuser',
        name: 'maintainuser',
        meta: {
          title: '个人信息维护'
        },
        component: () => import('@/views/userCenter/MaintainUser.vue')
      },
      {
        path: 'myappointment',
        name: 'myappointment',
        meta: {
          title: '我的预约'
        },
        component: () => import('@/views/userCenter/myAppointment/MyAppointment.vue')
        // component: MyAppointment
      },
      {
        path: 'collectlist',
        name: 'CollectList',
        meta: {
          title: '我的收藏'
        },
        component: () => import('../views/userCenter/CollectList.vue')
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/userCenter.js